const INITIAL_POSITION = 8192

export default {
    methods: {
        calculatePositionWhenAdded (collection, newIndex) {
            if (this.isEmpty) {
                return INITIAL_POSITION
            }

            // Moved to the first position
            if (newIndex === 0) {
                return collection[0].position / 2
            }

            // Moved to the last position, note the item isn't in the array yet, hence the newIndex === jobs.length
            if (newIndex === collection.length) {
                return collection[newIndex - 1].position + INITIAL_POSITION
            }

            // Moving between items forces all other items up, this is similar to a visual move up
            return (collection[newIndex].position + collection[newIndex - 1].position) / 2
        },

        calculatePositionWhenMoved (collection, newIndex, oldIndex) {
            // If first -> set to 1/2 of next item
            if (newIndex === 0) {
                return collection[0].position / 2
            }

            // Moved to the last position
            if (newIndex === collection.length - 1) {
                return collection[collection.length - 1].position + INITIAL_POSITION
            }

            // Visually move RIGHT if renderd (left to right, in asc index order)
            // Visually move DOWN if renderd (top to bottom, in asc index order)
            if (newIndex > oldIndex) {
                return (collection[newIndex].position + collection[newIndex + 1].position) / 2
            }

            // Visually move LEFT if renderd (left to right, in asc index order)
            // Visually move UP if renderd (top to bottom, in asc index order)
            if (newIndex < oldIndex) {
                return (collection[newIndex].position + collection[newIndex - 1].position) / 2
            }

            console.error('Unhandled move case', newIndex, oldIndex)
        }
    }
}
